import React,{ useState } from 'react';
import { toast } from 'react-toastify';
import MyFiltrers from './MyFiltrers';

// eslint-disable-next-line import/no-anonymous-default-export
const Todos = ({self}) => {
	const branches = self.state.sucursales;
	const [paginate, setPaginate] = useState([]);
	const [report, setReport] = useState([]);

	let list_branches = [], list_report=[];
	if( Array.isArray(branches)&&branches.length>0){
		branches.forEach(item=>{
			if(item.nombre!=='Bodega'){
				list_branches.push(<th key={item.id}>{item.nombre}</th>);
			}
		});
	}
	if( Array.isArray(report)&&report.length>0){
		let itemReport=[];
		report.forEach((item,index)=>{
			
			item.sucursales.forEach(product=>{
				itemReport.push(<td key={product.codigo}>{product.cantidad}</td>);
			});
			list_report.push(
				<tr key={index}>
					<td>{item.codigo}</td>
					<td style={{textAlign: 'left'}}>{item.nombre}</td>
					<td>{window.$fmoney(item.precio, 2)}</td>
					<td>{item.cantidad}</td>
					{itemReport}
				</tr>
			);
			itemReport = [];
		});
	}
	const requestReport = arg => {
		let display = { load : !self.state.display.load };
		self.setState({display});
		fetch(arg)
		.then(res=>res.json())
		.then(res=>{
			if(res.data.length > 0){
				setReport(res.data);
				setPaginate(res.paginate);
			}else{
				toast.warning("No hay registros para este rango de fechas");
			}
			display = { load : !self.state.display.load };
			self.setState({display});
		});
	}
	let dots = [];
	if( Array.isArray(paginate.list)&&paginate.list.length>0){
		paginate.list.forEach((item,index)=>{
			dots.push(
				<li key={index} 
					className={paginate.currentPage === item[0]?'active':''}
					onClick={()=>requestReport(item[1])}
					>
						{item[0]}
				</li>
			);
		});
	}
	
	return <>
		<MyFiltrers setPaginate={setPaginate} setReport={setReport} self={self}></MyFiltrers>
		<table>
			<thead>
				<tr>
					<th>Código</th>
					<th>Producto</th>
					<th>Precio</th>
					<th>Total</th>
					{list_branches}
				</tr>
			</thead>
			<tbody>{list_report}</tbody>
		</table>
		<div className="text-center">
			{paginate.hasOwnProperty('next_page_url')&&
				<ul className="pagination">
					<li onClick={()=>requestReport(paginate.first_page_url)}>Primera página</li>
					{paginate.prev_page_url&&<li onClick={()=>requestReport(paginate.prev_page_url)}>Anterior</li>}
					{dots.length>0&&dots}
					{paginate.next_page_url&&<li onClick={()=>requestReport(paginate.next_page_url)}>Siguiente</li>}
					{paginate.currentPage!==paginate.last_page&&<li onClick={()=>requestReport(paginate.last_page_url)}>Última página</li>}
				</ul>
			} 
		</div>
	</>
}

export default Todos;